import type { SharedLocale } from "../../core/schema/SharedLocale.js";
import type { SharedTenantId } from "../../core/schema/SharedTenant.js";
import type { TenantizedString } from "../../core/schema/Tenant.js";
import type { VertiNodeTenantizedString } from "../../core/schema/VertiNodeTenant.js";

export const sharedGlobalSettingsContextKey = "sharedGlobalSettings";

export interface SharedGlobalSettings {
	ENV: string;
	ENV_DOMAIN: string;
	PUBLIC_GRAPHQL_ENDPOINT: string;
	RECAPTCHA_SITE_KEY: string;
	ROBOTS: "index" | "noindex";
	STORAGE_URL: string;
	TENANT_ID: SharedTenantId;
	TENANT_LOCALE: SharedLocale;
	UPLOAD_URL: string;
	VERSION: string;
	VERTIFLEX_WEB_URL: TenantizedString;
	VERTINODE_WEB_URL: VertiNodeTenantizedString;
}
